import {Component, ElementRef, OnDestroy, OnInit, ViewChild} from '@angular/core';
import 'amazon-connect-streams';
import 'amazon-connect-chatjs';
import {AgentCCPService} from 'app/core/agent-ccp/agent-ccp.service';

@Component({
    selector: 'agent-ccp-widget',
    templateUrl: './agent-ccp-widget.component.html',
    styleUrls: ['./agent-ccp-widget.component.scss']
})
export class AgentCCPWidgetComponent implements OnInit, OnDestroy {
    showWidget = false;

    @ViewChild('ccpWidgetContainer', {static: true})
    ccpWidgetContainer: ElementRef;

    private ccpWidgetVisibilitySubscription: any;

    /**
     * Constructor
     */
    constructor(private agentCcpService: AgentCCPService) {}

    ngOnInit(): void {
        this.ccpWidgetVisibilitySubscription = this.agentCcpService.getCCPWidgetVisibilitySubject().subscribe((isVisible) => {
            this.showWidget = isVisible ?? false;
        });
    }

    ngOnDestroy(): void {
        this.ccpWidgetVisibilitySubscription.unsubscribe();
    }

    private doInitialization(): void {
        this.agentCcpService.initCCP(this.ccpWidgetContainer);
    }

    public showCCPanel(evt: Event) {
        this.doInitialization();
        this.agentCcpService.showCCPWidget();
    }

    public closeCCPanel(evt: Event) {
        this.agentCcpService.closeCCPWidget();
    }
}
